import React from "react";
import { useI18n } from "@/i18n/I18nContext";

export default function StepIndicator({ current, total }) {
  const { t } = useI18n();
  const labels = ["step1Title", "step2Title", "step3Title", "step4Title", "step5Title"];
  return (
    <div className="flex items-center gap-2">
      {Array.from({ length: total }).map((_, i) => (
        <div key={i} className="flex flex-1 flex-col items-center gap-2" data-testid={`wizard-step-${i + 1}`}>
          <div
            className={`h-1.5 w-full rounded-full transition-colors ${i <= current ? "bg-primary" : "bg-border"}`}
          />
          <span className={`hidden text-[11px] font-medium sm:block ${i === current ? "text-primary" : "text-muted-foreground"}`}>
            {t(`wizard.${labels[i]}`)}
          </span>
        </div>
      ))}
    </div>
  );
}
